import type { DriverDayOffType } from '@/backend/market'
import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'
import type { FileUploadEntity } from '@/shared/entities/FileUploadEntity'

export class PostDriverDayOffEntity {
  driver?: DriverEntity | null
  startDate?: Date | string | null
  endDate?: Date | string | null
  type?: DriverDayOffType
  reason?: string | null
  attachmentImage?: FileUploadEntity | null
  reviewNotes?: string | null
}
